import { RnPackPoolMV } from "../../../services/rnapi2-service/models/models";

export class PackageGroup {
  Name: string;
  Values: RnPackPoolMV[] = [];
  Description: string;
}
